/** 
*@author Mustafa Omran 
*/

import { Component } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HeaderBannerService } from './../../../services/Home/header-banner.service';

@Component({
  selector: 'martmax-header-banner',
  templateUrl: './header-banner.component.html',
  styleUrls: ['./header-banner.component.css'],
  providers: [HeaderBannerService],
})


export class HeaderBannerComponent {

  public headerBanner: any;
  public errors: any;

  constructor(public headerBannerService: HeaderBannerService) {

  }
  public ngOnInit() {

    this.headerBannerService.getCoupon().subscribe(
      (data) => {
        if (data.length === 0) {
          return;
        }
        this.headerBanner = data.headerBanner;
      },
      (errors) => {
        this.errors = errors;
      }
    );

  }

  /**
   * hide banner 
   * 
   * display block none !
   */
  public hideBanner() {
    /**
     * @todo replace jQuery with typescript 
     */
      $(".banner img").hide();
      $(".hide-banner").hide();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/header-banner/header-banner.component.ts